<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> Placeholder Instructions </mat-panel-title>
      <mat-panel-description> Placeholders allow you to dynamically generate values. </mat-panel-description>
    </mat-expansion-panel-header>

    <!-- Panel content -->
    <div>
      <p class="as-error-text">
        <strong
          >Warning! Using placeholders is an advanced configuration. The suggested placeholder values work for most
          situations.</strong
        >
      </p>
      <p>
        Placeholder expressions are enclosed by double curly braces <code>{{ '{{}}' }}</code>.
      </p>
      <p>
        You can insert a placeholder by beginning to type an expression in the editor with <code>{{ '{{' }}</code
        >.
      </p>
    </div>
    <button mat-raised-button (click)="onViewTemplatesClick()" style="float: right">View Available Templates</button>
  </mat-expansion-panel>
</mat-accordion>
